import { render, staticRenderFns } from "./CalculateForm.vue?vue&type=template&id=8c52cf4c"
import script from "./CalculateForm.vue?vue&type=script&lang=js"
export * from "./CalculateForm.vue?vue&type=script&lang=js"
import style0 from "./CalculateForm.vue?vue&type=style&index=0&id=8c52cf4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports